export default "__VITE_ASSET__D3XD1s7C__"